import { Flex, Divider, Box, Text, Stack } from "@chakra-ui/react";
import { TAvsCardData } from "@components/AVS/types";
import BaseImage from "@components/BaseImage";
import React from "react";

function AvsCard({ cardData }: { cardData: TAvsCardData }) {
  const { title, desc, imgUrl, amtDel, rewards } = cardData;

  const imageBgForWhiteLogo =
    title.toLowerCase() == "openlayer" ? { backgroundColor: "#000" } : {};
  return (
    <Flex
      minW="300px"
      w="full"
      justifyContent="space-between"
      alignItems="stretch"
    >
      <Flex
        bgColor={"backgroundCard"}
        pb={5}
        px={4}
        borderRadius={20}
        minW="300px"
        minH={{ base: 0, sm: "200px", md: "380px", lg: "410px", xl: "340px" }}
      >
        <Stack justifyContent={"space-between"} alignItems={"stretch"}>
          <Flex gap={4} p={4} direction={"row"} flex={1}>
            <Box
              mt={1}
              borderRadius={"12px"}
              minHeight={"30px"}
              minWidth={"30px"}
            >
              <Box {...imageBgForWhiteLogo}>
                <BaseImage src={imgUrl} alt={""} width={"30"} height={"30"} />
              </Box>
            </Box>
            <Flex direction={"column"}>
              <Text fontSize={"20px"} fontWeight={600}>
                {title}
              </Text>
              <Text fontSize={"14px"} mt={4}>
                {desc}
              </Text>
            </Flex>
          </Flex>
          <Divider mb={2} />
          <Flex flexDirection={"column"} gap={2} px={"20px"} fontSize={"14px"}>
            <Flex justifyContent={"space-between"}>
              <Text>Amount Delegated</Text>
              <Text>{amtDel} ETH</Text>
            </Flex>
            <Flex justifyContent={"space-between"}>
              <Text>Rewards</Text>
              <Text>{rewards}</Text>
            </Flex>
          </Flex>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default AvsCard;
